import type { EntityState } from '@reduxjs/toolkit';

import type {
  BDRequestType,
  OperationStatus,
} from '~/common/models/apis/apiResponse.model';
import type {
  ContinuationCache,
  ListViewSession,
  OperationSession,
  SearchCriteria,
} from '~/common/models/common.model';
import type {
  PeripheralListItem,
  PeripheralMoveFleetSummary,
  PeripheralOnboardStatusResponse,
  PeripheralsOnboardResponse,
  PeripheralType,
} from '~/common/models/peripheral.model';
import type { PeripheralFilterCriteria } from '~/routes/organizations/devices/peripheral/state/PeripheralFilter.model';

import type { PeripheralRequestType } from './peripheralsSlice';

export enum PeripheralsSessionViewType {
  LIST_VIEW = 'LIST_VIEW',
}

export enum PeripheralRowAction {
  UNASSIGN = 'unassign',
  REMOVE = 'remove',
}
export interface RowActionContent {
  peripheralId: string;
  peripheralImei: string;
  organizationId: string;
  hubId: string;
  fleetId: string;
  rowAction: PeripheralRowAction;
}

export interface PeripheralsListSession
  extends ListViewSession,
    OperationSession {
  importModalOpen?: boolean;
  onboardState: PeripheralsOnboardResponse;
  selectedIds?: string[];
  selectedItems?: PeripheralListItem[];
  allSelectedItems?: PeripheralListItem[];
  peripherals?: EntityState<PeripheralListItem>;
  allSelected?: boolean;
  onboardStateStatus: PeripheralOnboardStatusResponse;
  errorSnackbarOpen?: boolean;
  rowActionContent?: RowActionContent;
  filterType?: PeripheralFilterCriteria;
  filterModalOpen?: boolean;
  moveFleetSummary?: PeripheralMoveFleetSummary;
  searchCriteria?: SearchCriteria;
  peripheralType?: PeripheralType;
  continuationCache?: ContinuationCache<PeripheralListItem[]>;
}

export type PeripheralsSessionConfig = {
  [PeripheralsSessionViewType.LIST_VIEW]?: {
    [key: string]: Partial<PeripheralsListSession>;
  };
};

export interface PeripheralsState {
  items: EntityState<PeripheralListItem>;
  sessionConfigs: PeripheralsSessionConfig;
  operations: {
    [key in BDRequestType | PeripheralRequestType]?: OperationStatus;
  };
}
